module.exports = __webpack_public_path__ + "img/tf.b444aed9.svg";